<template>
  <div v-if="linhaDoTempo" :class="['linha-do-tempo-da-solicitacao', modificadorDoDestaque]">
    <ol class="linha-do-tempo-da-solicitacao__regua" aria-label="Linha do tempo da solicitação">
      <li v-for="numero in linhaDoTempo.TotalDeEtapas" :key="numero" class="linha-do-tempo-da-solicitacao__etapa">
        <span v-if="deveExibirBadgeNaEtapa(numero)" class="linha-do-tempo-da-solicitacao__badge">
          <span class="linha-do-tempo-da-solicitacao__badge-rotulo">{{ linhaDoTempo.NomeDaEtapaAtual }}</span>
          <svg class="linha-do-tempo-da-solicitacao__badge-seta" width="6.9282" height="6" viewBox="0 0 6.9282 6"
            xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" focusable="false">
            <path d="M3.4641 0L6.9282 6H0L3.4641 0Z" fill="currentColor" />
          </svg>
        </span>
        <span :class="['linha-do-tempo-da-solicitacao__segmento', classeDoSegmento(numero)]"></span>
      </li>
    </ol>

    <div v-if="estaEmAndamento" class="linha-do-tempo-da-solicitacao__rodape">
      <span class="titulo titulo_micro linha-do-tempo-da-solicitacao__vizinha">Etapa anterior: {{ linhaDoTempo.NomeDaEtapaAnterior }}</span>
      <span class="titulo titulo_micro linha-do-tempo-da-solicitacao__posicao">Etapa {{ linhaDoTempo.NumeroDaEtapaAtual }} de {{ linhaDoTempo.TotalDeEtapas }}</span>
      <span
        class="titulo titulo_micro linha-do-tempo-da-solicitacao__vizinha linha-do-tempo-da-solicitacao__vizinha_proxima">Próxima etapa: {{ linhaDoTempo.NomeDaProximaEtapa }}</span>
    </div>

    <div v-else-if="possuiDesfecho" class="linha-do-tempo-da-solicitacao__desfecho">
      <i :class="['linha-do-tempo-da-solicitacao__desfecho-icone', 'fas', iconeDoDesfecho]" aria-hidden="true"></i>
      <span class="titulo titulo_micro">{{ textoDoDesfecho }}</span>
    </div>

    <div v-else class="linha-do-tempo-da-solicitacao__desfecho linha-do-tempo-da-solicitacao__desfecho_sem-etapa">
      <span class="titulo titulo_micro">Situação não encontrada</span>
    </div>
  </div>
</template>

<script>
const EM_ANDAMENTO = 1;
const ENCERRADA = 2;
const CONCLUIDA = 3;

const modificadoresPorEstado = {
  [EM_ANDAMENTO]: 'linha-do-tempo-da-solicitacao_em-andamento',
  [ENCERRADA]: 'linha-do-tempo-da-solicitacao_encerrada',
  [CONCLUIDA]: 'linha-do-tempo-da-solicitacao_concluida',
};

const ATENCAO = 2;
const PRAZO_VENCIDO = 3;

const modificadoresPorDestaque = {
  [ATENCAO]: 'linha-do-tempo-da-solicitacao_atencao',
  [PRAZO_VENCIDO]: 'linha-do-tempo-da-solicitacao_prazo-vencido',
};

const prefixosDoDesfecho = {
  [ENCERRADA]: 'Processo encerrado',
  [CONCLUIDA]: 'Processo concluído',
};

export default {
  props: {
    linhaDoTempo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    estaEmAndamento() {
      return this.linhaDoTempo.Estado === EM_ANDAMENTO;
    },
    possuiDesfecho() {
      return this.linhaDoTempo.Estado === ENCERRADA || this.linhaDoTempo.Estado === CONCLUIDA;
    },
    modificadorDoDestaque() {
      if (this.estaEmAndamento) {
        const modificador = modificadoresPorDestaque[this.linhaDoTempo.DestaqueDaEtapaAtual];
        if (modificador) return modificador;
      }

      return modificadoresPorEstado[this.linhaDoTempo.Estado] || '';
    },
    iconeDoDesfecho() {
      return this.linhaDoTempo.Estado === CONCLUIDA ? 'fa-check' : 'fa-times';
    },
    textoDoDesfecho() {
      const prefixo = prefixosDoDesfecho[this.linhaDoTempo.Estado];
      return `${prefixo} · ${this.linhaDoTempo.NomeDaEtapaAtual} em ${this.linhaDoTempo.DataDoDesfecho}`;
    },
  },
  methods: {
    deveExibirBadgeNaEtapa(numero) {
      return numero === this.linhaDoTempo.NumeroDaEtapaAtual && !!this.linhaDoTempo.NomeDaEtapaAtual;
    },
    classeDoSegmento(numero) {
      const etapaAtual = this.linhaDoTempo.NumeroDaEtapaAtual;

      if (etapaAtual == null || numero > etapaAtual) {
        return 'linha-do-tempo-da-solicitacao__segmento_futuro';
      }

      return numero === etapaAtual
        ? 'linha-do-tempo-da-solicitacao__segmento_atual'
        : 'linha-do-tempo-da-solicitacao__segmento_concluido';
    },
  },
};
</script>



// WEBPACK FOOTER //
// LinhaDoTempoDaSolicitacao.vue?32bc8d24